import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { useRecoilValue } from 'recoil';

const ListingDetailLink = (props) => {
    const currentSite = useRecoilValue(atoms.currentWebsite);

    const getLinkClassName = () => {
        let baseClass = "view-listing-details-link des-view-listingDetails template-branded-button";

        if (currentSite?.Site.IsAuctionTime || currentSite?.Site.IsBidcaller) {
            if (props.IsAT) {
                if (currentSite?.IsAuctionTimeAuctionSite && (props.isAuctionOnToday || props.IsAuctionLive)) {
                    baseClass += " at-bid-now-link";
                } else {
                    baseClass += " at-view-details";
                }
            }
            if (props.IsEF) {
                baseClass += " ef-view-details";
            }
        }
        return baseClass;
    };   

    const getDisplayText = () => {     
        if (props.IsAT && currentSite?.IsAuctionTimeAuctionSite && !props.IsAuctionResult && (props.IsAuctionLive || props.isAuctionOnToday)) {
            var bidAmount = props.NextBidAmount ? props.NextBidAmount : '';
            return translator.translate('sandhills.tradepubwebsite.mvc.bidnowtext') + ' ' + bidAmount;
        }
   
        return translator.translate('sandhills.tradepubwebsite.mvc.viewdetails');
    };

    const getAriaLabelText = () => {
        if (props.IsAT && currentSite?.IsAuctionTimeAuctionSite && !props.IsAuctionResult && (props.IsAuctionLive || props.isAuctionOnToday)) {
            var bidAmount = props.NextBidAmount ? props.NextBidAmount : '';
            return translator.translate('sandhills.tradepubwebsite.mvc.bidnowtext') + ' ' + bidAmount;
        }

        return translator.translate('sandhills.tradepubwebsite.mvc.viewdetailsfor') + ' ' + props.AriaLabelTitle
    }

    const getIconClass = () => {
        if (props.IsAT && currentSite?.IsAuctionTimeAuctionSite && !props.IsAuctionResult && (props.IsAuctionLive || props.isAuctionOnToday)) {
            return "fas fa-gavel";
        }

        return "fas fa-search-plus";
    };

    const isUpcomingAuction = () => {
        return ((props.IsAT && currentSite?.IsAuctionTimeAuctionSite) || (props.IsEF && currentSite?.IsBidCallerAuctionSite)) && !props.IsAuctionResult;
    };

    return (
        <span>
            <a className={getLinkClassName()} href={props.DetailUrl} onClick={() => props.IsSimilar && gtmPushEvent(gtmEventType.noListingsSimilarResultClick)} target={props.openDetailPageInNewTab ? "_blank" : "_self"} aria-label={props.openDetailPageInNewTab ? getAriaLabelText() + " (" + translator.translate('sandhills.opensinanewtab') + ")" : getAriaLabelText()}>
                <i className={getIconClass()} aria-hidden="true"></i>
                {getDisplayText()}
            </a>
        </span>
        );
}

export default ListingDetailLink;